import API from '../api'
import putUrl from './paths'

export const updateDisaptchInvoiceWeight = (dispatchPlanId, invoiceNumber, newWeight, userId) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateDisaptchInvoiceWeight, {}, { dispatchPlanId, invoiceNumber, newWeight, userId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const addDispatchInvoice = (dispatchPlanId, orderId, originalInvoiceNumber, userId) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.addDispatchInvoice, {}, { dispatchPlanId, orderId, originalInvoiceNumber, userId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const updateDispatchPlanStatus = (dispatchPlanId, dispatchRemark, dispatchPlanStatus, planStartDate, userId) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateDispatchPlanStatus, { ...dispatchRemark }, { dispatchPlanId, dispatchPlanStatus, planStartDate, userId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const addVehicleDriverDetails = (dispatchPlanId, vehicleDriverDetails, userId) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.addVehicleDriverDetails, { ...vehicleDriverDetails }, { dispatchPlanId, userId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const updateVehicleDriverDetailsStatus = (dispatchPlanId, vehicleDriverDetails, userId) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateVehicleDriverDetailsStatus, { ...vehicleDriverDetails }, { dispatchPlanId, userId })
			.then((response) => resolve(response))
			.catch((error) => {
				reject(error)
			})
	})

// the vehicle number, driver number and quantity of a vehicle can be updated
export const updateVehicleDetails = (dispatchPlanId, vehicleId, vehicleDetails, userId) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateVehicleDetails, { ...vehicleDetails }, { dispatchPlanId, vehicleId, userId })
			.then((response) => resolve(response))
			.catch((error) => {
				reject(error)
			})
	})

// sets the delay status of a vehicle
export const updateVehicleDelayStatus = (userId, dispatchPlanId, vehicleId, delayStatus) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateVehicleDelayStatus, {}, { userId, dispatchPlanId, vehicleId, delayStatus })
			.then((response) => resolve(response))
			.catch((error) => {
				reject(error)
			})
	})

export const updateDispatchPlanStartDate = (dispatchPlanId, planStartDate, userId) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateDispatchPlanStartDate, {}, { dispatchPlanId, planStartDate, userId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})
